import { mapGetters, mapActions } from 'vuex'

export const signingReviewActions = {
  ...mapActions('signingReviewStore', [
    'setDataReview'
  ])
}

export const signingReviewData = {
  ...mapGetters('signingReviewStore', [
    'reviewFileName',
    'reviewFileSize',
    'reviewHash',
    'reviewRazonSocial',
    'reviewRFC'
  ])
}
  